/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  error.ts
 * @Package :
 * @author:青瞳科技
 * @date:   2022/1/19 11:27
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 青瞳科技
 * 注意：本内容仅限于深圳青瞳科技有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

import { Component, Vue } from 'vue-property-decorator'
import { AxiosError } from 'axios'
import {saveFrontLog} from "@/api/commonConfig";
import store from "@/store";
import getBrowserInfo from 'get-browser-info'

/**
 * 上报异常信息
 * @export
 * @param {Parameter} [parameter={}]
 * @returns
 */
export function catchError(parameter: { [prop: string]: any } = {}) {
  saveFrontLog(parameter).then()
}

let __VM__: Vue = new Vue()

@Component
export class LogMixin extends Vue {
  created() {
    __VM__ = this
  }
}

const params: { [x: string]: any } = {
  fullPath: '', // 地址
  routeUrl: '', // 路由
  exceptionMsg: '', // 异常信息
  exceptionType: '', // 分类
  exceptionProject: 'supply-tech-app', // 项目
  userId: '', // 用户id
  code: '', // 后端返回code码
  // userName: '', // 用户名称
  token: '',
  browserType: '', // 浏览器类型
  browserVersion: '', // 浏览器版本
  requestParam: '', // 请求报文
  responseParam: '', // 返回报文
}

function handleEmpty(value: any) {
  return value || ''
}

// 系统错误捕获
export const errorHandler = (error: AxiosError, type = 'js-error') => {
  try {
    params.fullPath = decodeURIComponent(window.location.href)
    params.routeUrl = handleEmpty(__VM__.$route.path)
    // params.routeUrl = handleEmpty(window.location.pathname)
    params.exceptionType = type
    params.userId = handleEmpty(store.state.user.info.userId)
    // params.userName = handleEmpty(store.state.info.username)
    params.token = handleEmpty(store.state.user.token)
    params.exceptionMsg = handleEmpty(`${error.message} ${error.stack}`)
    params.browserType = getBrowserInfo().browser
    params.browserVersion = getBrowserInfo().browserVersion
    if (type === 'request-error') {
      params.code = JSON.stringify(error.code)
      params.responseParam = JSON.stringify(error.response)
      params.requestParam = JSON.stringify(error.request)
      // 过滤掉上报接口请求报错时重复调用上报接口
      if ((error.request.responseURL as string).includes('/log/frontlog')) {
        return false
      }
      const filterStates: number[] = [401]
      if (error.response && filterStates.includes(error.response.status))
        return false
    }
    // eslint-disable-next-line no-empty
  } catch (e) {}
  catchError(params)
}
Vue.config.errorHandler = (error: AxiosError, vm: Vue, info: any) =>
    errorHandler(error, 'js-error')
Vue.prototype.$throw = function (error: AxiosError) {
  return errorHandler(error, 'request-error')
}
